/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoiceIndexPathParams, InvoiceIndexResponse } from '../types/InvoiceIndex'

/**
 * GET /:organisation/invoices
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::index
 */
export async function invoiceIndex(
	organisation: InvoiceIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceIndexResponse>> {
	return axiosInstance.get(`/${organisation}/invoices`, config)
}
